import React, { Component } from "react";
import { registerForLocalization, provideLocalizationService } from "@progress/kendo-react-intl";
import { Grid, GridColumn } from "@progress/kendo-react-grid";
import { PotvrdenieStavEnum } from "../../../enums";
import { Input } from "@progress/kendo-react-inputs";
import Moment from "moment";

class NahlasenieEditaciaDialogContent extends Component {
    state = {
        dialog: {
            title: null,
            content: null,
            width: null,
            height: null
        }
    };

    constructor(props) {
        super(props);
        this.nahlasenie = this.props.nahlasenie;
        this.baliky = this.getBaliky(this.nahlasenie.baliky);
        this.rozdiely = this.getRozdiely(this.nahlasenie.baliky);
    }

    getBaliky(baliky) {
        var i = 1;
        baliky = baliky.filter(item => {
            item.id = i++;
            item.polozka = this.nahlasenie.modDachser ? this.getPackingText(item.packing) : item.kodBalika;
            item.rozdielKsText = item.potvrdenieStavKs === PotvrdenieStavEnum.NIC ? "" : item.rozdielKs;
            item.skutKsText = item.potvrdenieStavKs === PotvrdenieStavEnum.NIC ? "" : item.rozdielKs + item.pocetKs;
            item.potvrdenieStavKsText = this.getStavText(item.potvrdenieStav);
            return true;
        });
        return baliky;
    }

    getStavText(stav) {
        switch (stav) {
            case PotvrdenieStavEnum.NIC:
                return "";
            case PotvrdenieStavEnum.OK:
                return "OK";
            case PotvrdenieStavEnum.CHYBA:
                return "CHÝBA";
            case PotvrdenieStavEnum.NAVIAC:
                return "NAVIAC";
            case PotvrdenieStavEnum.ROZDIEL:
                return "ROZDIEL";
            case PotvrdenieStavEnum.ZAMENA:
                return "ZÁMENA";
            default:
                return "???";
        }
    }

    getPackingText(packing) {
        return packing === 13 ? packing.substring(1, 6) : packing;
    }

    getRozdiely(baliky) {
        var rozdielyArr = [];
        baliky.forEach(item => {
            for (var i = 0; i < item.nahlPole.length; i++) {
                var rozdiel = {
                    id: item.nahlPole[i].id,
                    polozka: i == 0 ? this.getRozdilPolozkaText(this.nahlasenie.modDachser, item) : "", // TODO
                    textArtikel: item.nahlPole[i].textArtikel,
                    pocetKs: item.nahlPole[i].pocetKs
                };
                rozdielyArr.push(rozdiel);
            }
        });
        return rozdielyArr;
    }

    getRozdilPolozkaText(isDachser, balik) {
        if (isDachser) {
            return this.getPackingText(balik.packing);
        } else {
            return balik.kodBalika;
        }
    }

    render() {
        var localizationService = provideLocalizationService(this);
        return (
            <div>
                <div className="col-sm-6">
                    <Grid style={{ height: "530px" }} data={this.baliky}>
                        <GridColumn field="polozka" title={localizationService.toLanguageString("NahlasenieKusy.Grid.Položka", "Položka")} />
                        <GridColumn field="typTovaru" title={localizationService.toLanguageString("NahlasenieKusy.Grid.Typ", "Typ")} width="70px" />
                        <GridColumn field="pocetKs" title={localizationService.toLanguageString("NahlasenieKusy.Grid.Ks", "Ks")} />
                        <GridColumn field="potvrdenieStavKsText" title={localizationService.toLanguageString("NahlasenieKusy.Grid.Stav", "Stav")} />
                        <GridColumn field="rozdielKsText" title={localizationService.toLanguageString("NahlasenieKusy.Grid.Rozdíl", "Rozdíl")} />
                        <GridColumn field="skutKsText" title={localizationService.toLanguageString("NahlasenieKusy.Grid.Skut.ks", "Skut.ks")} />
                    </Grid>
                </div>
                <div className="col-sm-6">
                    <Grid style={{ height: "300px" }} data={this.rozdiely}>
                        <GridColumn field="polozka" title={localizationService.toLanguageString("NahlasenieKusy.Grid.Položka", "Položka")} />
                        <GridColumn
                            field="textArtikel"
                            title={localizationService.toLanguageString("NahlasenieKusy.Grid.Zjištěné rozdíly", "Zjištěné rozdíly")}
                        />
                        <GridColumn field="pocetKs" title={localizationService.toLanguageString("NahlasenieKusy.Grid.Rozdíl ks", "Rozdíl ks")} width="70px" />
                    </Grid>
                    <div className="k-form">
                        <div className="row" style={{ marginTop: "10px" }}>
                            <div className="col-xs-6">
                                <div className="k-form-field">
                                    <span>{localizationService.toLanguageString("NahlasenieKusy.Počet ks", "Počet ks")}</span>
                                    <Input value={this.nahlasenie.dodavkaPocetKs} disabled />
                                </div>
                            </div>
                            <div className="col-xs-6">
                                <div className="k-form-field">
                                    <span>{localizationService.toLanguageString("NahlasenieKusy.Rozdíl ks", "Rozdíl ks")}</span>
                                    <Input value={this.nahlasenie.dodavkaRozdilKs} disabled />
                                </div>
                            </div>
                            <div className="col-xs-offset-6 col-xs-6">
                                <div className="k-form-field">
                                    <span>{localizationService.toLanguageString("NahlasenieKusy.Skutečný počt ks", "Skutečný počt ks")}</span>
                                    <Input value={this.nahlasenie.dodavkaSkutPocetKs} disabled />
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-xs-offset-6 col-xs-6">
                                <span>{localizationService.toLanguageString("NahlasenieKusy.Dátum a čas prijatí tovaru", "Dátum a čas prijatí tovaru")}</span>
                                <div className="k-form-field">
                                    <Input value={Moment(this.nahlasenie.datumPrijatiaTovaru).format("D.M.YYYY H:mm:ss") || ""} disabled />
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-xs-offset-6 col-xs-6">
                                <span>
                                    {localizationService.toLanguageString(
                                        "NahlasenieKusy.Dátum a čas vyložení na prodejnu",
                                        "Dátum a čas vyložení na prodejnu"
                                    )}
                                </span>
                                <div className="k-form-field">
                                    <Input value={Moment(this.nahlasenie.datumVylozeniaTovaru).format("D.M.YYYY H:mm:ss") || ""} disabled />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default NahlasenieEditaciaDialogContent;

registerForLocalization(NahlasenieEditaciaDialogContent);



// WEBPACK FOOTER //
// ./src/components/dialogs/RucniNahlasenieDodavky/NahlasenieEditaciaDialogContent.js